import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-subtitle1"
}
const _hoisted_2 = { class: "text-subtitle1" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("strong", null, "permanently deleted", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_client_loader = _resolveComponent("client-loader")!
  const _component_async_btn = _resolveComponent("async-btn")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    title: "Confirmation",
    size: "xs",
    ref: "modal"
  }, {
    actions: _withCtx(() => [
      _createVNode(_component_async_btn, {
        task: _ctx.task,
        label: "Remove",
        color: "negative",
        onClick: _ctx.confirm
      }, null, 8, ["task", "onClick"])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_client_loader, {
        "client-id": _ctx.clientId,
        modelValue: _ctx.client,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.client) = $event))
      }, null, 8, ["client-id", "modelValue"]),
      (_ctx.client)
        ? (_openBlock(), _createElementBlock("p", _hoisted_1, [
            _createTextVNode(" Are you sure you want to remove the "),
            _createElementVNode("strong", null, _toDisplayString(_ctx.socialSiteName), 1),
            _createTextVNode(" account of "),
            _createElementVNode("strong", null, _toDisplayString(_ctx.$filters.clientName(_ctx.client)), 1),
            _createTextVNode("? ")
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("p", _hoisted_2, [
        _createTextVNode(" All posts related to this account will be "),
        _hoisted_3,
        _createTextVNode(" from Private Footprint. This has no impact on the client's " + _toDisplayString(_ctx.socialSiteName) + " account. ", 1)
      ])
    ]),
    _: 1
  }, 512))
}